<template>
  <div>
    <table
      class="table table-striped"
      v-if="FulfillmentData != undefined"
      style="text-align: left"
    >
      <thead class="thead-light">
        <tr>
          <th>Status</th>
          <th>Count</th>
          <th>Reasons</th>
          <!-- <th>Detail Description</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="(value, text, index) in FulfillmentData" :key="index">
          <td>{{ text }}</td>
          <td>{{ value.count }}</td>
          <template v-if="value.short_reasons == undefined">
            <td></td>
            <!-- <td style="background-color:#757575">
                            NaN
                        </td> -->
          </template>
          <template v-else>
            <!-- <td>
                            <template v-for="(value,text,index) in value.short_reasons">
                                <div :key="index">{{text}}: {{value.count}}</div>
                            </template>
                        </td> -->
            <td>
              <template v-for="(value, text, index) in value.short_reasons">
                <!-- <v-card class="mx-auto border"  :key="index" style="margin-top:3px;padding-left:5px;"> -->
                <div
                  :key="index"
                  class="border"
                  style="
                    padding: 3px 3px 3px 3px;
                    margin-top: 3px;
                    background-color: white;
                  "
                >
                  <b style="color: #1e88e5">{{ text }}: {{ value.count }}</b>
                  <div v-for="(i, index) in value.detail_reasons" :key="index">
                    <b>{{ i.order_number }}: </b>
                    {{ i.detail_reason }}
                  </div>
                </div>
                <!-- </v-card> -->
              </template>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "BackEndFulfillment",
  props: {
    FulfillmentData: Object,
  },
  data: () => ({}),
  methods: {
    loadData() {
      for (const i in this.FulfillmentData) {
        this.FulfillmentData[i]["showData"] = false;
      }
      //console.log(JSON.stringify(this.FulfillmentData))
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
</style>